import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { StripeBillingPortalSession } from '@/modules/billing/models/stripe/StripeBillingPortalSession';

export class StripeBillingPortalSessionResource extends BaseResource {
  async createSession(returnUrl: string): Promise<StripeBillingPortalSession> {
    return StripeBillingPortalSession.mapModel(
      await this.postData(Route.BILLINGS_CREATEBILLINGPORTALSESSION, { returnUrl })
    );
  }
}

export default new StripeBillingPortalSessionResource();
